import { useGetAllCustomersQuery } from "../../services/userCRUDApi";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { PeopleAltOutlined } from "@mui/icons-material";
import { AdminPageHeader, AdminToolbar, AdminTable, AdminRowActions } from "../../components/ui";

export default function Customers() {
  const { data, isLoading } = useGetAllCustomersQuery();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const allRows = data?.results ?? [];
  const term = search.trim().toLowerCase();
  const rows = term
    ? allRows.filter(
        (c) =>
          `${c.first_Name} ${c.last_Name}`.toLowerCase().includes(term) ||
          (c.email || "").toLowerCase().includes(term) ||
          (c.phone_Number || "").includes(term)
      )
    : allRows;

  const columns = [
    { key: "id", header: "ID", width: 70 },
    { key: "name", header: "Name", render: (c) => `${c.first_Name} ${c.last_Name}` },
    { key: "email", header: "Email" },
    { key: "phone_Number", header: "Phone" },
    {
      key: "actions",
      header: "",
      align: "right",
      render: (c) => (
        <AdminRowActions label={`${c.first_Name} ${c.last_Name}`} onEdit={() => navigate(`/admin/customer/edit/${c.id}`)} />
      ),
    },
  ];

  return (
    <div>
      <AdminPageHeader
        title="Customers"
        subtitle="View and manage registered customers."
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Customers" }]}
      />
      <AdminToolbar searchValue={search} onSearchChange={setSearch} searchPlaceholder="Search customers by name, email or phone..." />
      <AdminTable
        columns={columns}
        rows={rows}
        rowKey={(c) => c.id}
        isLoading={isLoading}
        emptyIcon={<PeopleAltOutlined />}
        emptyTitle={search ? "No customers match your search" : "No customers yet"}
        pageSize={10}
      />
    </div>
  );
}
